import { useEffect, useState } from "react";

const getIstanbulHour = () =>
  parseInt(
    new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      hour12: false,
      timeZone: "Europe/Istanbul",
    }).format(new Date()),
    10
  );

export const OpenStatus = ({ compact = false }) => {
  const [open, setOpen] = useState(() => {
    const h = getIstanbulHour();
    return h >= 8 && h < 23;
  });

  useEffect(() => {
    const t = setInterval(() => {
      const h = getIstanbulHour();
      setOpen(h >= 8 && h < 23);
    }, 60_000);
    return () => clearInterval(t);
  }, []);

  const color = open ? "text-green-400" : "text-amber-400";
  const dot = open ? "bg-green-400" : "bg-amber-400";
  const label = open
    ? compact
      ? "Şu an açık — hemen geliyoruz"
      : "Şu an açık · 08:00 – 23:00 · Hemen geliyoruz"
    : compact
      ? "Mesai dışı — acil durumlarda 7/24 arayın"
      : "Şu an mesai dışı · Acil durumlarda 7/24 arayabilirsiniz";

  return (
    <span
      data-testid="open-status-badge"
      className="inline-flex items-center gap-2.5"
    >
      <span className="relative flex h-2 w-2">
        <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${dot} opacity-75`} />
        <span className={`relative inline-flex rounded-full h-2 w-2 ${dot}`} />
      </span>
      <span className={`font-mono text-[11px] tracking-[0.18em] uppercase ${color}`}>
        {label}
      </span>
    </span>
  );
};
